import { Device } from '@capacitor/device';
export async function isAndroidWithoutPdfSupport(): Promise<boolean> {
  const { androidSDKVersion, platform } = await Device.getInfo();
  const minAndroidSdkVersionWithPdfPreviewSupport = 35;
  return (
    platform === 'android' &&
    Number(androidSDKVersion) < minAndroidSdkVersionWithPdfPreviewSupport
  );
}
